import { makeObservable, observable, action } from 'mobx';
import SettingsRequests from 'Utils/Requests/SettingsRequests';
import React from 'react';
import { ShowAlert } from "Utils/CommonFunctions";

class IntegrationSettingsStore {
    dmsis;
    carma;
    settingsLoading;

    constructor() {
        makeObservable(this, {
            dmsis: observable,
            carma: observable,
            settingsLoading: observable
        });
        this.dmsis = {
            servicePath: '',
            status: '',
            hasError: false,
            dmsisTime: '[НЕДОСТУПНО]',
            localTime: '[НЕДОСТУПНО]',
            dmsisVersion: '[НЕДОСТУПНО]'
        };
        this.carma = {
            servicePath: '',
            status: '',
            hasError: false
        };
        this.settingsLoading = false;
    }

    GetSettings = action(() => {
        if (this.settingsLoading)
            return;

        this.settingsLoading = true;

        SettingsRequests.GetIntegrationSettings()
            .then(action((values) => {
                this.dmsis.servicePath = (values.serviceUrl == null) ? '' : values.serviceUrl;
                this.carma.servicePath = (values.carmaInitString == null) ? '' : values.carmaInitString;
            }))
            .finally(action(() => this.settingsLoading = false));
    });

    SetDmsisState = action((state) => {
        this.dmsis = {
            servicePath: this.dmsis.servicePath,
            status: state.liveStatus,
            hasError: state.hasError,
            dmsisTime: state.remoteTime,
            localTime: state.localTime,
            dmsisVersion: state.dmsisVersion
        }
    });

    SetCarmaState(state) {
        this.carma.status = state.status;
        this.carma.hasError = state.hasError;
    }

    SetDmsisServicePath = action((path) => {
        this.dmsis.servicePath = path;
    });

    SaveSettings = action(() => {
        if (this.settingsLoading)
            return;

        this.settingsLoading = true;

        SettingsRequests.SaveIntegrationSettings({ serviceUrl: this.dmsis.servicePath, carmaInitString: this.carma.servicePath })
            .then(action(values => {
                if (!values.error) {
                    ShowAlert('success', 'Настройки успешно сохранены.');
                } else {
                    ShowAlert('error',
                        <div>
                            При сохранении настроек произошла ошибка.<br />
                            {(values.error.errorText == null ? 'Убедитесь что СМР работает и повторите попытку.' : values.error.errorText)}
                        </div>
                    );
                }
            }))
            .finally(action(() => this.settingsLoading = false));
    });
}

export default new IntegrationSettingsStore();